const EditingView = ({
  textInput,
  setTextInput,
}: {
  textInput: string;
  setTextInput: (value: string) => void;
}) => {
  return (
    <div className="p-4 md:p-12 w-full flex justify-center items-center">
      <textarea
        autoFocus
        className="w-full max-w-3xl bg-background text-text-primary leading-7 md:leading-9 h-72 md:h-96 p-3 md:p-4 text-xl md:text-3xl rounded-md focus:outline-none border-none focus:ring-0 resize-none"
        placeholder="Start Typing..."
        value={textInput}
        onChange={(e) => setTextInput(e.target.value)}
      />
    </div>
  );
};

export default EditingView;
